const _platforms = {
  "Windows NT": "windows",
  Linux: "linux",
};

export const platforms = Object.values(_platforms);

export function getOS() {
  const userAgent = window.navigator.userAgent;

  for (const platform in _platforms) {
    if (userAgent.indexOf(platform) !== -1) {
      return _platforms[platform];
    }
  }
}

export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
